export default "__VITE_ASSET__Wlk4Y4WA__"